import posthog from 'posthog-js';

// PostHog configuration
const POSTHOG_KEY = 'phc_kPVQfQIc1ZTXSimQUK4gpLNiZG7RUDQsB1qqzUYK3CG';
const POSTHOG_HOST = 'https://us.i.posthog.com';

/**
 * Initialize PostHog with proper configuration for user tracking
 */
export const initPosthog = () => {
  if (typeof window === 'undefined') return;

  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: 'always', // Changed from 'identified_only' to capture all users
      loaded: (posthog) => {
        if (import.meta.env.DEV) {
          posthog.debug();
        }
      },
      capture_pageview: false, // We'll handle this manually
      capture_pageleave: true,
      persistence: 'localStorage',
      // Remove problematic session recording config that can cause MIME errors
      disable_session_recording: false,
      // Prevent loading external config files that might cause MIME errors
      disable_persistence: false,
      cross_subdomain_cookie: false,
    });

    console.log('PostHog initialized');
  } catch (error) {
    console.warn('PostHog initialization failed:', error);
  }
};

/**
 * Identify a user when they log in
 */
export const identifyUser = (userId: string, userProperties?: Record<string, any>) => {
  if (typeof window === 'undefined') return;

  try {
    posthog.identify(userId, {
      ...userProperties,
      // Add timestamp for identification
      identified_at: new Date().toISOString(),
    });
    
    console.log('PostHog user identified:', userId);
  } catch (error) {
    console.error('PostHog identify error:', error);
  }
};

/**
 * Reset PostHog when user logs out
 */
export const resetPosthog = () => {
  if (typeof window === 'undefined') return;

  try {
    posthog.reset();
    console.log('PostHog user reset');
  } catch (error) {
    console.error('PostHog reset error:', error);
  }
};

/**
 * Track a pageview manually
 */
export const trackPageview = (path?: string) => {
  if (typeof window === 'undefined') return;

  try {
    const currentPath = path || window.location.pathname + window.location.search;
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      $pathname: currentPath,
    });
    
    console.log('PostHog pageview tracked:', currentPath);
  } catch (error) {
    console.error('PostHog pageview error:', error);
  }
};

/**
 * Track custom events
 */
export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  if (typeof window === 'undefined') return;

  try {
    posthog.capture(eventName, properties);
    console.log('PostHog event tracked:', eventName, properties);
  } catch (error) {
    console.error('PostHog event error:', error);
  }
};

export default posthog;